<template>
  <div>
  <input
      @input="(event) => $emit('change-multi-checkbox:checked', event.target.checked)"
      type="checkbox"
      :checked="checked"
      :id="fieldId"
      :disabled="disabled"
      class="mr-2 hidden"
      @click="onClick(fieldId, $event)"
  />
  <label
      :for="fieldId"
      class="flex flex-row items-center font-bold text-gray-800 cursor-pointer select-none"
  >
<!--    <i-->
<!--        class="fa mr-2"-->
<!--        :class="{-->
<!--        'fa-check-square text-blue-600': checked,-->
<!--        'fa-square text-gray-500': !checked,-->
<!--      }"-->
<!--    ></i>-->
    {{ label }}
  </label>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    fieldId: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  methods: {
    onClick(fieldId, $event) {
      console.log("event = ")
      console.log($event)
      // if (fieldId==="ROLE_FINANCIER") {
      //
      // } else {
      //   $event.preventDefault()
      // }

    }
  }
};
</script>

<style>
</style>
